import styled from 'styled-components';

interface DriverOrderDto {
  name: string; // 기업명
  orderCount: number; // 발주 건수
}

export const OrderSection = ({ orders }: { orders: DriverOrderDto[] }) => {
  return (
    <Wrap>
      <span className="title">
        오늘 발주 건수
        <span className="count">{orders.length}</span>
      </span>
      {orders && orders.length > 0 ? (
        <div className="today-orders">
          <div className="inner">
            {orders.map((order, index) => (
              <div className="order" key={index}>
                <span className="company-name">{order.name}</span>
                <span className="company-count">
                  <span className="number">{order.orderCount}</span>
                  <span className="company-count-unit">건</span>
                </span>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <p className="no-orders">발주가 없습니다.</p>
      )}
    </Wrap>
  );
};

// style
const Wrap = styled.section`
  margin-top: 3.2rem;
  .no-orders {
    font-size: 1.6rem;
    min-height: 8.4rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .title {
    display: flex;
    align-items: center;
    gap: 1rem;
    font-size: 1.6rem;
    font-weight: 600;
    margin-bottom: 1.4rem;
    .count {
      display: flex;
      width: 3rem;
      height: 2.2rem;
      align-items: center;
      justify-content: center;
      font-size: 1.2rem;
      line-height: 1.5rem;
      font-weight: 600;
      color: ${(props) => props.theme.textWhiteColor};
      background-color: ${(props) => props.theme.btnBlueColor};
      border-radius: 1.1rem;
      padding: 0.4rem 0 0.3rem;
    }
  }
  .today-orders {
    width: 100%;
    position: relative;
    min-height: 8.4rem;
    .inner {
      height: 9.4rem;
      display: flex;
      gap: 0.8rem;
      position: absolute;
      left: -2rem;
      padding: 0 2rem;
      width: 100vw;
      overflow: scroll hidden;
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
      .order {
        display: flex;
        flex: 0 0 auto;
        flex-direction: column;
        justify-content: space-between;
        width: 9.4rem;
        height: 8.4rem;
        border-radius: 1.6rem;
        background-color: ${(props) => props.theme.textWhiteColor};
        padding: 1.2rem;
        box-shadow: rgba(188, 191, 209, 0.2) 0px 2px 6px;
        .company-name {
          color: ${(props) => props.theme.textOrderColor};
          font-size: 1.3rem;
          font-weight: 600;
        }
        .company-count {
          display: flex;
          justify-content: flex-end;
          align-items: flex-end;
          gap: 0.3rem;
          .number {
            font-size: 2rem;
            font-weight: 600;
            color: ${(props) => props.theme.btnBlueColor};
          }
          .company-count-unit {
            font-size: 1.2rem;
            font-weight: 600;
            color: ${(props) => props.theme.textBlackColor};
            opacity: 0.6;
            line-height: 1.8rem;
          }
        }
      }
      &::-webkit-scrollbar {
        display: none; /* Chrome, Safari, Opera*/
      }
    }
  }
`;
